import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { ClientLocationCamerasService } from '../services/client_location_cameras.service'
import { defaultQueryOptions } from './common'
import { ClientLocationCamerasList, ClientLocationCamerasConfig } from '../types/cameras-api'

export const useClientLocationCameras = (
  locationName: string,
  lupId: string
): UseQueryResult<ClientLocationCamerasList> => {
  return useQuery<ClientLocationCamerasList>({
    queryKey: ['clientLocationCameras', locationName, lupId],
    queryFn: () => ClientLocationCamerasService.getCamerasList(locationName, lupId),
    enabled: !!lupId,
    ...defaultQueryOptions,
  })
}

export const useClientLocationCamerasAccess = (
  locationName: string,
  lupId: string
): UseQueryResult<ClientLocationCamerasConfig> => {
  return useQuery<ClientLocationCamerasConfig>({
    queryKey: ['clientLocationCamerasAccess', locationName, lupId],
    queryFn: () => ClientLocationCamerasService.getCamerasAccess(locationName, lupId),
    enabled: !!lupId,
    ...defaultQueryOptions,
  })
}
